// Auto-generated slideshow images configuration
// This file is automatically updated when you run: npm run update-slideshow

const slideshowImages = [
    `${process.env.PUBLIC_URL}/images/slideshow/103.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/104.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/105.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/107.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/113.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/119.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/120.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/121.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/122.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/123.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/124.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/125.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/126.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/127.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/128.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/129.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/13.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/130.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/133.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/134.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/135.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/136.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/139.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/14.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/140.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/141.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/142.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/143.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/144.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/145.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/146.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/148.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/149.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/15.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/150.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/151.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/152.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/153.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/156.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/157.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/158.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/16.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/160.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/163.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/164.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/165.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/166.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/167.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/168.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/169.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/17.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/170.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/171.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/172.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/173.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/174.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/175.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/176.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/177.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/178.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/179.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/18.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/180.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/181.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/182.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/183.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/184.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/185.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/186.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/187.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/188.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/189.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/19.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/190.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/191.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/192.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/193.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/194.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/195.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/197.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/198.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/199.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/20.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/23.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/24.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/25.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/26.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/27.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/28.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/29.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/30.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/31.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/32.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/33.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/34.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/35.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/39.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/40.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/41.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/42.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/43.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/44.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/47.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/48.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/49.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/50.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/51.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/52.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/53.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/54.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/55.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/56.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/57.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/58.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/59.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/63.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/64.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/65.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/67.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/68.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/69.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/70.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/71.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/72.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/74.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/75.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/76.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/78.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/79.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/80.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/81.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/82.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/83.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/85.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/86.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/89.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/90.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/91.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/92.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/93.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/94.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/95.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/98.jpg`,
    `${process.env.PUBLIC_URL}/images/slideshow/ig3.jpeg`,
    `${process.env.PUBLIC_URL}/images/slideshow/ig4.jpeg`,
    `${process.env.PUBLIC_URL}/images/slideshow/ig6.jpeg`,
    `${process.env.PUBLIC_URL}/images/slideshow/ig7.jpeg`,
    `${process.env.PUBLIC_URL}/images/slideshow/ig11.jpeg`,
    `${process.env.PUBLIC_URL}/images/slideshow/ig12.jpeg`,
    `${process.env.PUBLIC_URL}/images/slideshow/ig13.jpeg`,
    `${process.env.PUBLIC_URL}/images/slideshow/ig14.jpeg`,
    `${process.env.PUBLIC_URL}/images/slideshow/ig17.jpeg`,
    `${process.env.PUBLIC_URL}/images/slideshow/ig20.jpeg`,
    `${process.env.PUBLIC_URL}/images/slideshow/ig21.jpeg`,
    `${process.env.PUBLIC_URL}/images/slideshow/ig22.jpg`
];

export default slideshowImages;
